import React from "react";
import { Button, Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Hero.css";

const Hero = () => {


    function readMore(e) {
      e.preventDefault();
      console.log('read more');
    }


  return (
    <div>


      <Carousel>
        <Carousel.Item>
          <div className="image1">
            <div className="wordwrap">
              <h2 className="banner-pad">First Class</h2>
              <h1 className="bigtext">Factories</h1>
              <p>Get quotations Inspect factories and samples</p>
              <Link to="/about">
                <Button variant="primary" size="lg">
                  READ MORE
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline-light" size="lg">
                  GET IN TOUCH
                </Button>
              </Link>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="image2">
            <div className="wordwrap">
              <h2 className="banner-pad">Applying</h2>
              <h1 className="bigtext">For a Travel Visa?</h1>
              <p>Flight. Hotel. Transport. Translation</p>
              <Link to="/about">
                <Button variant="primary" size="lg">
                  READ MORE
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline-light" size="lg">
                  GET IN TOUCH
                </Button>
              </Link>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="image3">
            <div className="wordwrap">
              <h2 className="banner-pad">The package</h2>
              <h1 className="bigtext">Professional Products</h1>
              <p>Get samples from two or more factories</p>
              <Link to="/about">
                <Button variant="primary" size="lg">
                  READ MORE
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline-light" size="lg">
                  GET IN TOUCH
                </Button>
              </Link>
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="image4">
            <div className="wordwrap">
              <h2 className="banner-pad">Follow up</h2>
              <h1 className="bigtext">After Sales</h1>
              <p>Making sure our clients are happy</p>
              <Link to="/about">
                <Button variant="primary" size="lg">
                  READ MORE
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline-light" size="lg">
                  GET IN TOUCH
                </Button>
              </Link>
            </div>
          </div>
        </Carousel.Item>

      </Carousel>

    </div>
  );
};

export default Hero;
